import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.795 4.779l-1.464-1.063-.559-1.721h-1.809L10.499.932 9.035 1.995H7.226l-.559 1.721-1.464 1.063.559 1.721-.559 1.721 1.464 1.063.332 1.021V19.5c0 .184.102.354.264.441s.36.077.513-.025l2.723-1.815 2.723 1.815c.084.056.18.084.277.084.081 0 .162-.02.236-.059a.4987.4987 0 00.264-.441v-9.195l.332-1.021 1.464-1.063-.559-1.721.559-1.721zm-5.018 12.305a.5004.5004 0 00-.555 0l-2.223 1.482v-7.561h1.036l1.464 1.063 1.464-1.063h1.036v7.561l-2.223-1.482h.001zm3.843-9.245l-1.139.827L13.048 10H13v.004h-1.361l-1.139.827-1.139-.827H7.954l-.435-1.339-1.139-.827.435-1.339L6.38 5.16l1.139-.827.435-1.339h1.407l1.139-.827 1.139.827h1.407l.435 1.339 1.139.827-.435 1.339.435 1.339v.001z',
  ],
  height: 20,
  width: 20,
});
